module.exports = __webpack_public_path__ + "84c413e58b731ae221b8db65db1cf381.pdf";